import { render, staticRenderFns } from "./TasksEditPhoto.vue?vue&type=template&id=01a6890c&scoped=true&"
import script from "./TasksEditPhoto.vue?vue&type=script&lang=js&"
export * from "./TasksEditPhoto.vue?vue&type=script&lang=js&"
import style0 from "./TasksEditPhoto.vue?vue&type=style&index=0&id=01a6890c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a6890c",
  null
  
)

export default component.exports